import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row } from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { AiOutlineFileSearch } from "react-icons/ai";
import { getDateDifference } from "../../../../../utilities/durationutility";
import { ProfileService } from "../../../../../services/ProfileService";
import { isNullOrEmpty } from "../../../../../config/ENV";
import sortArray from "sort-array";

const JOBExperiences = () => {
  const [jobExperiences, setJobExperiences] = useState([]);
  const [experinceId, setExperinceId] = useState("");
  const [experinceName, setExperinceName] = useState("");
  const [ModalLong, setModalLong] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [showView, setShowView] = useState(false);

  const [filteredPresentList, setFilteredPresentList] = useState([]);

  const filterExperience = (exp) => {
    var x = exp.filter((expItem) => expItem.endDate === 0);
    var p1 = sortArray(x, { by: "startDate", order: "desc" });
    var y = exp.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var z = exp.filter((expItem) => expItem.startDate === 0);
    setFilteredPresentList([...z, ...p1, ...y]);
  };

  useEffect(() => {
    getCandidateExperience();
  }, []);
  const history = useHistory();
  const handleCancelButton = () => {
    history.push("/smartresume");
  };
  const onAddExperience = (experienceId) => {
    // window.localStorage.setItem("experienceId", id);
    // history.push("/candidateaddexperience");
    const data = { id: experienceId };
    history.push({
      pathname: "/candidateaddexperience",
      state: data,
    });
  };

  const getCandidateExperience = () => {
    ProfileService.getExperience().then((response) => {
      try {
        if (response.data !== null) {
          var experienceDetails = response.data;
          if (experienceDetails.exps != null) {
            if (response.data.exps.length > 0) {
              for (let i = 0; i < response.data.exps.length; i++) {
                response.data.exps[i].isRead = true;
              }
              setJobExperiences(response.data.exps);
              filterExperience(response.data.exps);
            } else {
              setJobExperiences([]);
              filterExperience([]);
            }
          }
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  const approveParsedExperience = (expId) => {
    ProfileService.approveResumeParsedExperience(expId).then((response) => {
      try {
        getCandidateExperience();
      } catch (err) {
        console.error("approveResumeParsedExperience" + JSON.stringify(err));
      }
    });
  };

  const handledeletesoftskill = (deleteId, name) => {
    setExperinceId(deleteId);
    setExperinceName(name);
    setModalLong(true);
  };
  const onDeleteExperience = () => {
    deleteCandidateExperience();
    setModalLong(false);
  };

  const back = () => {
    setModalLong(false);
  };

  const [isOpen, setIsOpen] = useState(false);

  const show = (id, index) => {
    setIsOpen(!isOpen);
    if (selectedId == id) {
      setShowView(!showView);
    } else {
      setShowView(true);
    }
    setSelectedId(id);
    // const expData = [...jobExperiences];
    // expData[index].isRead = !expData[index].isRead;
    // setJobExperiences(expData);
    const experienceData = [...filteredPresentList];
    experienceData[index].isRead = !experienceData[index].isRead;
    setFilteredPresentList(experienceData);
  };

  const deleteCandidateExperience = () => {
    ProfileService.deleteExperience(experinceId).then((response) => {
      try {
        if (response.data != null) {
          // toast.success("Job experience deleted successfully");
          getCandidateExperience();
        }
      } catch (err) {
        console.error("deleteExperience" + JSON.stringify(err));
      }
    });
  };

  const getAddress = (addressObj) => {
    const address = [];
    if (addressObj != null) {
      if (addressObj.city != null) {
        address.push(addressObj.city + ", ");
      }

      if (addressObj.state != null) {
        address.push(addressObj.state);
      }
    }

    return address;
  };

  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">



<div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="addexperience right">
              <div className="skill-header">
                <div>
                  <div className="profile-card-title">
                      <h2 className="t-h2-font-sm">
                        <strong>Job Experience</strong>
                      </h2>
                    <div className="row">
                      <div className="col">
                        Your Smart Resume™ would be stronger with skills linked
                        to each job.
                      </div>
                    </div>

                    <div className="horizontal_line mt-2"></div>
                  </div>

                  <div className="row mt-3">
                    <div className="col">
                      <TeamanicsButton onClick={() => onAddExperience("")}>
                        Add Job Experience
                      </TeamanicsButton>
                    </div>
                    <div className="col t-button-flex-end">
                      <div className="row">
                        <div className="">
                          <AiOutlineFileSearch
                            color="red"
                            size="20"
                            title="Please review smart resume"
                          />
                        </div>
                        <div className="">
                          Info scanned from your resume, please review
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {filteredPresentList.length > 0 ? (
              <>
                <Row className="mb-1 mt-3">
                  <Colxx xxs="12">
                    {filteredPresentList.length > 0 ? (
                      filteredPresentList.map((jobExperience, index) => {
                        return (
                          <div
                            key={index}
                            className="min-sm:bg-white min-sm:shadow-lg min-sm:rounded-2xl min-sm:border min-sm:px-6 min-sm:py-8 w-full mb-5 t-padding-bottom-[12px] t-padding-top-[12px]"
                            style={{
                              borderRight:
                                jobExperience.fromParse === true
                                  ? "4px solid red"
                                  : "",
                            }}
                          >
                            <div>
                              <div className="row">
                                <div className="ml-3 mt-1">
                                  {jobExperience.fromParse === true ? (
                                    <div
                                      style={{
                                        color:
                                          jobExperience.fromParse === true
                                            ? "red"
                                            : "",
                                      }}
                                    >
                                      <AiOutlineFileSearch
                                        className="t-hand-cursor-pointer"
                                        size="20"
                                        title="Info scanned from your resume, please review"
                                      />
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="font-semibold text-lg text-primary-blue">
                                  {jobExperience.position}
                                </div>
                              </div>

                              <div>{jobExperience.employer}</div>

                              <div>{getAddress(jobExperience.address)}</div>
                              <p>
                                {jobExperience.startDate == 0 ? (
                                  <></>
                                ) : (
                                  <>
                                    {jobExperience.startDate !== 0 &&
                                    jobExperience.endDate == 0 ? (
                                      <>
                                        {moment(jobExperience.startDate).format(
                                          "MM/YYYY"
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {moment(jobExperience.startDate).format(
                                          "MM/YYYY"
                                        ) +
                                          " - " +
                                          moment(jobExperience.endDate).format(
                                            "MM/YYYY"
                                          )}
                                      </>
                                    )}
                                  </>
                                )}{" "}
                                <span className="font-normal text-sm">
                                  {" "}
                                  {jobExperience.startDate == 0 ||
                                  jobExperience.endDate == 0 ? (
                                    <></>
                                  ) : (
                                    <>
                                      (
                                      {getDateDifference(
                                        jobExperience.startDate,
                                        jobExperience.endDate
                                      )}
                                      )
                                    </>
                                  )}
                                </span>
                              </p>
                              {!isNullOrEmpty(jobExperience.description) && (
                                <a>
                                  <span
                                    className="t-hand-cursor-pointer text-primary-blue"
                                    onClick={() =>
                                      show(jobExperience.id, index)
                                    }
                                  >
                                    {jobExperience.isRead ? (
                                      <>
                                        See Less{" "}
                                        <i className="simple-icon-arrow-down t-icon-size-[8px]" />
                                        <div className="t-description-text-color t-parsed-text">
                                          {jobExperience.description}
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        See More{" "}
                                        <i className="simple-icon-arrow-up t-icon-size-[8px]" />
                                      </>
                                    )}
                                  </span>
                                </a>
                              )}
                              <div>
                                <>
                                  <div className="row">
                                    <div className="">
                                      <span
                                        className="t-hand-cursor-pointer"
                                        onClick={() => {
                                          onAddExperience(jobExperience.id);
                                        }}
                                      >
                                        <TeamanicsButton
                                          className="mt-3 ml-3"
                                        >
                                          Edit
                                        </TeamanicsButton>
                                      </span>
                                    </div>

                                    <TeamanicsButton
                                      className="ml-2 mt-3"
                                      onClick={() =>
                                        handledeletesoftskill(
                                          jobExperience.id,
                                          jobExperience.employer
                                        )
                                      }
                                    >
                                      Delete
                                    </TeamanicsButton>

                                    {jobExperience.fromParse === true ? (
                                      <span title="Accept Experience Entry">
                                        <TeamanicsButton
                                          className="mt-3 ml-2"
                                          onClick={() =>
                                            approveParsedExperience(
                                              jobExperience.id
                                            )
                                          }
                                        >
                                          Accept
                                        </TeamanicsButton>
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Colxx>
                  {/* <div className="col">
                    <Button onClick={handleCancelButton}>Save</Button>
                  </div> */}
                  <div>
                <TeamanicsButton
                className="mt-3 ml-3"
                  onClick={handleCancelButton}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                  className="ml-2"
                  onClick={handleCancelButton}
                  >
                    Save
                  </TeamanicsButton>
                 
                </div>
                </Row>
              </>
            ) : (
              <>
                <Row className="loginname">
                  <label>No data found</label>
                </Row>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        id="exampleModal"
        isOpen={ModalLong}
        toggle={() => setModalLong(!ModalLong)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
        <ModalHeader>
          <div>
            <label className="modal-title" id="exampleModalLabel">
              Delete job experience
            </label>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <label>Do you want to delete {experinceName} Jobexperience?</label>
          </div>
        </ModalBody>

        <ModalFooter className="model-button t-modal-footer-btn">
          <div>
            <TeamanicsButton onClick={back}>Close</TeamanicsButton>{" "}
            <TeamanicsButton
              onClick={() => {
                onDeleteExperience();
              }}
            >
              Delete
            </TeamanicsButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default JOBExperiences;
